<template>
  <div>
    <slot v-if="ready" :serverData="serverData"></slot>
    <div v-else-if="loading">
      Carregando...
    </div>
    <div v-else-if="error">
      <v-card flat class="pa-10" color="transparent">
        <v-card-title class="text-h4">
          <v-icon color="red" left size="40">mdi-close-circle-outline</v-icon>
          {{ errorTitle }}
        </v-card-title>
        <v-card-text>
          {{ errorMessage }}
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="returnTo" :to="returnTo" outlined color="primary">
            Retornar
          </v-btn>
          <v-btn
            :to="{ name: 'dashboard' }"
            v-else
            outlined
            color="primary"
            exact
          >
            <v-icon left>mdi-home</v-icon> Início
          </v-btn>
          <v-btn @click="load()" outlined color="secondary">
            <v-icon>mdi-refresh</v-icon> Recarregar</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    action: Function,
    handlePrepare: Function,
    returnTo: [String, Object],
    autoLoad: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      ready: false,
      loading: false,
      error: false,
      errorMessage: "",
      errorTitle: "",

      serverData: null
    };
  },

  methods: {
    prepareData(serverData) {
      if (this.handlePrepare) {
        return this.handlePrepare(serverData);
      }

      return serverData;
    },

    async load() {
      this.ready = false;
      this.loading = true;
      this.error = false;
      this.errorMessage = "";

      try {
        const response = await this.action();
        this.serverData = this.prepareData(response);
        this.ready = true;
      } catch (error) {
        console.error(error);

        this.error = true;

        if (error.response?.status === 404) {
          this.errorTitle = "Página não encontrada...";
          this.errorMessage =
            "A página que você está tentando acessar não existe ou foi movida";
          return;
        }

        if (error.response?.status === 401) {
          this.errorTitle = "Proibido";
          this.errorMessage =
            "Você não possui permissões para acessar o conteúdo desta página.";
          return;
        }

        this.errorTitle = "Erro não identificado...";
        this.errorMessage =
          "Infelizmente ocorreu um erro ao exibir essa página, tente novamente em alguns minutos e se o erro persistir entre em contato com o suporte.";
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {},

  created() {
    if (this.autoLoad) {
      this.load();
    }
  }
};
</script>
